/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useCallback, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import BodyContent from 'components/BodyContent';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import esLocale from '@fullcalendar/core/locales/es';
import {
  Card, Col, Row,
} from 'react-bootstrap';
import * as bootstrap from 'bootstrap';
import RelevantEventsCard from 'components/Calendar/RelevantEvents';
import calendar from 'assets/icons/calendar-2.svg';
import clock from 'assets/icons/clock.svg';
import RelevantEventsListCard from 'components/Calendar/RelevantEventsList';
import { DatesSetArg } from '@fullcalendar/core';
import moment from 'moment';
import { EventProps } from 'types/Event';
import EventDetailModal from 'components/Calendar/EventDetail';

function CalendarView( { events, getData }: {
  events?: EventProps[],
  getData: ( month: number, year: number ) => void
} ) {
  const { t } = useTranslation();
  const currentPopover: any = null;
  const calendar2Ref = useRef<any>( null );
  const [syncedMonth, setSyncedMonth] = useState<string>();
  const [showEventDetailModal, setEventDetailModal] = useState( false );
  const selectedEventRef = useRef<EventProps>();

  const confirmAssitance = useCallback(
    // Reservado para integración futura con la API de asistencia
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ( eventId: string, action: 'MAYBE' | 'YES' ) => undefined,
    [],
  );

  const handleDateChange = ( arg: DatesSetArg ) => {
    const currentVisibleMonth = arg.view.currentStart;
    const currentYM = `${currentVisibleMonth.getFullYear()}-${currentVisibleMonth.getMonth()}`;

    if ( currentYM !== syncedMonth ) {
      const date = new Date( arg.view.currentStart );
      const month = date.getMonth() + 1; // getMonth() devuelve 0 para enero, así que sumamos 1
      const year = date.getFullYear();
      getData( month, year );
      setSyncedMonth( currentYM );

      const calendarApi = calendar2Ref.current?.getApi();
      if ( calendarApi ) {
        const dateToGo = new Date(
          currentVisibleMonth.getFullYear(),
          currentVisibleMonth.getMonth(),
        );

        calendarApi.gotoDate( dateToGo );
      }
    }
  };

  const closeEventDetailModal = useCallback( ( ) => {
    setEventDetailModal( false );
    selectedEventRef.current = undefined;
  }, [] );

  const openEventDetailModal = useCallback( ( event: EventProps ) => {
    selectedEventRef.current = event;
    setEventDetailModal( true );
  }, [] );

  return (
    <BodyContent
      classNames={{ body: 'position-relative dashboard mt-3' }}
    >
      <Row>
        <Col lg={4}>
          <RelevantEventsCard
            data={events}
            onDateChange={handleDateChange}
            fullHeight={false}
            onEventClick={openEventDetailModal}
          />
          <div className="mt-3">
            <RelevantEventsListCard
              data={events}
              fullHeight={false}
              onEventClick={openEventDetailModal}
            />
          </div>

        </Col>
        <Col lg={8} className="d-none d-lg-block">
          <Card className="calendar-lg">
            <FullCalendar
              height={880}
              plugins={[dayGridPlugin]}
              initialView="dayGridMonth"
              headerToolbar={false}
              ref={calendar2Ref}
              locale={esLocale}
              events={events}
              eventClick={( info ) => {
                openEventDetailModal( info.event.extendedProps as EventProps );
              }}
           /*    eventDidMount={( info ) => {
                const content = document.createElement( 'div' );
                const data = info.event.extendedProps;
                content.innerHTML = `
                    <div id="popover-content-${info.event.id}">
                      <div class="row mb-1">
                        <div class="col-7 d-flex align-items-center">
                          <img src="${calendar}" alt="icono" style="width: 10px; height: 10px; margin-right: 3px;" />
                          <p class="text--xxs text--gray28 m-0">${moment( data.fechaInicio ).format( 'dddd, MMMM D' )}</p></div>
                        <div class="col-5 d-flex align-items-center">
                          <img src="${clock}" alt="icono" style="width: 10px; height: 10px; margin-right: 3px;" />
                          <p class="text--xxs text--gray28 m-0">${data.allDate ? 'Todo el dia' : moment( data.fechaInicio ).format( 'HH:mm' )}</p>
                        </div>
                      </div>
                      <p class="text--xxs text--gray28 mb-2">Ubicación: Villa Alegría 123</p>

                      <p class="text--xs m-0 text--semibold">Descripción</p>
                      <p class="text--xxs text--gray28 mb-2">Lorem ipsum</p>

                      <p class="text--xs m-0 text--semibold">Link de llamada</p>
                      <p class="text--xxs text--gray28 mb-2">Lorem ipsum2</p>

                      <p class="text--xs mb-2 text--semibold">¿Confirmar asistencia?</p>
                      <div class="d-flex align-items-center">
                        <button id="custom-button-${info.event.id}-maybe" type="button" class="py-1 text--normal btn--rounded btn--full-width btn btn-outline-primary btn-sm">Quizás</button>
                        <button id="custom-button-${info.event.id}-yes" type="button" class="py-1 text--normal btn--rounded btn--full-width ms-2 btn btn-primary btn-sm">Aceptar</button>
                      </div>
                    </div>
                `;
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                const popover = new bootstrap.Popover( info.el, {
                  title: info.event.title,
                  placement: 'auto',
                  trigger: 'click',
                  html: true,
                  customClass: 'fc-event-popover',
                  content,
                } );

                info.el.addEventListener( 'shown.bs.popover', () => {
                  const btn = document.querySelector( `#custom-button-${info.event.id}-maybe` );
                  if ( btn ) {
                    btn.addEventListener( 'click', ( e ) => {
                      e.stopPropagation();
                      confirmAssitance( info.event.id, 'MAYBE' );
                    } );
                  }
                  const btnYes = document.querySelector( `#custom-button-${info.event.id}-yes` );
                  if ( btnYes ) {
                    btnYes.addEventListener( 'click', ( e ) => {
                      e.stopPropagation();
                      confirmAssitance( info.event.id, 'YES' );
                    } );
                  }
                } );

                info.el.addEventListener( 'click', ( e ) => {
                  e.stopPropagation();

                  if ( currentPopover && currentPopover !== popover ) {
                    currentPopover.hide();
                  }

                  if ( !info.el.getAttribute( 'aria-describedby' ) ) {
                    popover.show();
                    currentPopover = popover;
                  } else {
                    popover.hide();
                    currentPopover = null;
                  }
                } );

                document.addEventListener( 'click', ( e ) => {
                  if ( currentPopover && !info.el.contains( e.target as Node ) ) {
                    currentPopover.hide();
                    currentPopover = null;
                  }
                } );
              }} */
            />
          </Card>
        </Col>
      </Row>

      {showEventDetailModal && (
      <EventDetailModal
        data={selectedEventRef.current}
        onClose={closeEventDetailModal}
      />
      )}
    </BodyContent>
  );
}

export default CalendarView;
